<template>
	<div class="page">
		<div class="itme01">
			<div class="item01Iit">
				<img src="../../../assets/images/questionDescribe.png" height="17" width="13"  style="margin-right: 5px;" />
				问题描述
			</div>
			<div>
				<textarea v-model="problem"  class="areaSty" placeholder="请输入问题描述详情，最长200个字符" maxlength="200"></textarea>
			</div>
		</div>
		<div class="itme02">
			<mt-cell title="故障时间">
				<span style="color: #149ACD" @click="open('picker1')" size="large">
					<span id="selectDate">选择</span>
					<span class="rightArrow"></span>
				</span>
			</mt-cell>
		</div>
		<!-- <div class="itme03">
			<mt-cell title="选择设备">
				<span style="color: #149ACD">
					选择
					<span class="rightArrow"></span>
				</span>
			</mt-cell>
		</div> -->
		<div class="workBtn" @click="submitWorkSheet">
			提单
		</div>
		<mt-datetime-picker
			  ref="picker1"
			  v-model="value"
			  :closeOnClickModal="false"
			  @visible-change="handleVisibleChange" :end-date="new Date()"
			  @confirm="handleChange" :show-toolbar="true">
			  <div style="width: 200px; height: 30px; background: gold;"></div>
		</mt-datetime-picker>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	import { Toast,MessageBox  } from 'mint-ui';
	export default{
		name:'WcWorkM',
		data(){
			return{
				problem:'',
				time:'',
				value:new Date(),
				duration:3000,
				position:'bottom'
			}
		},
		methods:{
			open(picker) {
				this.$refs[picker].open();
				//this.createDateEle();
			  },

			  handleChange(value) {
				  var selectDate  = document.getElementById("selectDate");
				  var date = this.formatDate(value);
				  selectDate.innerHTML=date;
				Toast({
				  message: '已选择 ' + date,
				  position: 'bottom'
				});
				this.time=date;
			 },
			 handleVisibleChange(isVisible) {
				console.log('弹窗是否展示:', isVisible);
			},
			createDateEle(){
				var dateTitEl = document.createElement("div");
				dateTitEl.innerHTML='<div class="dataTit">'+
					'<div>Year</div>'+
					'<div>Mon</div>'+
					'<div>Day</div>'+
					'<div>Hour</div>'+
					'<div>Min</div>'+
				'</div>';
				var datePicker = document.getElementsByClassName("mint-datetime-picker")[0];
				var pickerItems = document.getElementsByClassName("picker-items")[0];
				datePicker.insertBefore(dateTitEl,pickerItems);
			},
			formatTen(num){//不足10加0
				//return num.toString().padStart(2,"0");
				return num>9?(num+""):("0"+num)
			},
			formatDate(date){
				var year  = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				var hour = date.getHours();
				var minute = date.getMinutes();
				return year +"-"+this.formatTen(month)+"-"+this.formatTen(day)+" "+this.formatTen(hour)+":"+this.formatTen(minute);
			},
			submitWorkSheet(){
				if(!this.problem){
					Toast({
					  message: '请输入问题描述',
					  position: this.position,
					  duration: this.duration
					});
					return;
				}
				if(!this.time){
					Toast({
					  message: '请选择故障时间',
					   position: this.position,
					  duration: this.duration
					});
					return;
				}
				_api('_worksheet','.code',{problem:this.problem,time:this.time},res=>{
					MessageBox('提示', '提单成功');
					this.problem='';
					this.value=new Date();
					var selectDate  = document.getElementById("selectDate");
				  	selectDate.innerHTML='';
				},err=>{
					
				})
			}
			
		},
		mounted:function(){
			this.createDateEle();
		}
	}
</script>

<style>
	body{
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
	}
	.page{
		padding-top: 1px;
		position: relative;
		top: 40px;
	}
	.page .itme01{
		height: 200px;
		margin-top: 5px;
		background: #FFFFFF;
		border-top: 1px solid #DBDBDB;
		border-bottom: 1px solid #DBDBDB;
		padding: 0 20px;
	}
	.page .areaSty{
		width: 100%;
		height: 135px;
		border: 1px solid #DBDBDB;
		background: #F7F7F7;
		padding: 5px;
	}
	.page .item01Iit{
		height: 40px;
		display: flex;
		align-items: center;
		color: #5B5B5B;
		font-size: 15px;
	}
	.page .itme02{
		height: 50px;
		margin-top: 10px;
		background: #FFFFFF;
		border-top: 1px solid #DBDBDB;
		border-bottom: 1px solid #DBDBDB;
	}
	.page .itme03{
		height: 50px;
		margin-top: 10px;
		background: #FFFFFF;
		border-top: 1px solid #DBDBDB;
		border-bottom: 1px solid #DBDBDB;
	}
	.page .mint-cell-wrapper{
		padding: 0 20px;
	}
	.page .mint-cell-text{
		color: #797979;
		font-size: 15px;
	}
	.page .mint-cell-value{
		font-size: 15px;
	}
	.page .rightArrow{
		display: inline-block;
		width: 6px;
		height: 12px;
		background:url(../../../assets/images/rightArrow.png) no-repeat;
		background-size:6px 12px;
		margin-left: 10px;
	}
	textarea::-webkit-input-placeholder{
	    color:#BABABA;
		
	}
	textarea::-moz-placeholder{   /* Mozilla Firefox 19+ */
	    color:#BABABA;
	}
	textarea:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
	    color:#BABABA;
	}
	textarea:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
	    color:#BABABA;
	}
	.page .workBtn{
		width: 70%;
		height: 40px;
		background:#31B0D3;
		border-radius: 40px;
		margin: 40px auto;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 15px;
	}
	.dataTit{
		width:100%;
		height: 30px;
		background: #FAFCFB;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.dataTit>div{
		text-align: center;
		width: 25%;
		font-size: 14px;
	}
	.picker-items{
		background: #E9F1F3;
		color: #9E9EA0;
	}
	.picker-slot{
		z-index: 9;
		font-size: 13px;
	}
	.picker-center-highlight{
		background: #D2EBEF;
	}
	.picker-item.picker-selected{
		color: #00AAD9;
	}
	.mint-datetime-cancel {
		float: left;
		text-align: left;
		padding-left: 25px;
		color: #000;
	}
	.mint-datetime-confirm{
		float: right;
		padding-right: 25px;
		color: #00A1D4;
	}
	.mint-datetime-action{
		width: auto;
		line-height: 45px;
	}
	.picker-toolbar{
		height: 45px;
	}
</style>



// WEBPACK FOOTER //
// src/components/worksheet/make/WcWorkM.vue